import { Component, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef, ViewChild, HostListener } from '@angular/core';
import { BaseInput } from '../base-input';
import { MakeProvider } from '../../abstract-custom-control';

@Component({
  selector: 'yt-input-html',
  templateUrl: './input-html.component.html',
  styleUrls: ['./input-html.component.scss'],
  providers: [MakeProvider(InputHtmlComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputHtmlComponent extends BaseInput {
  @ViewChild('editableDiv', { static: true }) editableDiv!: ElementRef<HTMLDivElement>;

  constructor(protected changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }
  charCount: number = 0;
  private lastInteractionWasKeyboard = false;
  
  
  ngAfterViewInit() {
    this.inputControl = this.editableDiv; 
    super.ngAfterViewInit();
    this.setSize();
    this.updateView();
  }

  onInput(event: Event) {
    const element = event.target as HTMLElement;
    let html = element.innerHTML;
  
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent.trim() || '';
  
    if (text === '') {
      html = '';
      element.innerHTML = '';
    }
  
    const htmlLength = html.length;
  
    if (this.MaxLength && htmlLength > this.MaxLength) {
      html = html.substring(0, this.MaxLength);
      element.innerHTML = html;
      this.setCaretToEnd(element);
    }
  
    this.charCount = htmlLength;
    this.value = html;
    this.OnValueChange.emit(html);
  }
  
@HostListener('document:keydown', ['$event'])
handleKeydown(event: KeyboardEvent) {
  if (event.key === 'Tab') {
    this.lastInteractionWasKeyboard = true;
  }
}

@HostListener('document:mousedown')
handleMousedown() {
  this.lastInteractionWasKeyboard = false;
}

@HostListener('focusin', ['$event'])
onFocusIn(event: FocusEvent) {
  if (this.isDisabled) return;

  if (
    this.lastInteractionWasKeyboard &&
    this.editableDiv &&
    this.value &&
    this.value.length > 0
  ) {
    this.selectAllContent();
  }

  this.isActive = true;
  this.changeDetectorRef.markForCheck();
}

@HostListener('focusout')
onFocusOut() {
  if (this.isDisabled) return;

  this.isActive = false;
  this.changeDetectorRef.markForCheck();
}

private selectAllContent() {
  const el = this.editableDiv.nativeElement;
  const range = document.createRange();
  range.selectNodeContents(el);

  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
}


setCaretToEnd(el: HTMLElement) {
  const range = document.createRange();
  const selection = window.getSelection();

  range.selectNodeContents(el);
  range.collapse(false); 

  selection.removeAllRanges();
  selection.addRange(range);
}

  writeValue(value: string) {
    super.writeValue(value);
    this.updateView();
  }

  updateView() {
    if (this.editableDiv) {
      this.editableDiv.nativeElement.innerHTML = this.value || '';
    }
  }
  

  setDisabledState(isDisabled: boolean) {
    super.setDisabledState(isDisabled);
    if (this.editableDiv) {
      this.editableDiv.nativeElement.contentEditable = String(!isDisabled);
    }
  }

  focus() {
    super.focus();
    setTimeout(() => {
      this.editableDiv.nativeElement.focus();
    }, 100);
  }

  keyDown(event: KeyboardEvent) {
    const el = this.editableDiv.nativeElement;
    const htmlLength = el.innerHTML.length;
  
    if (event.key === 'Enter') {
      event.preventDefault();
      return;
    }
  
    const navigacijaIliBrisanje =
    ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab'].indexOf(event.key!) !== -1;
  
  
    if (this.MaxLength && htmlLength >= this.MaxLength && !navigacijaIliBrisanje && !event.ctrlKey && !event.metaKey) {
      event.preventDefault(); 
    }
  }
  
  

  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
  
    if (target.tagName.toLowerCase() === 'a') {
      event.preventDefault();
      const href = (target as HTMLAnchorElement).href;
      window.open(href, '_blank');
    }
  }
  
  
}
